import React from 'react';
import { FormSelect } from '@getro/rombo';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';

import { FormikAutoSubmit } from '../../../../../atoms/formikAutoSubmit';
import { useNumberOfApplicantsFilter } from './useNumberOfApplicantsFilter';

export const NumberOfApplicantsFilter = ({ value, setFilters }) => {
  const { formSchema, onSubmit, numberOfApplicantsOptions } = useNumberOfApplicantsFilter({
    setFilters,
  });

  const selectedOption =
    numberOfApplicantsOptions.find((option) => option.value === value) ?? numberOfApplicantsOptions[0];

  return (
    <Formik
      initialValues={{ numberOfApplicants: selectedOption || '' }}
      validationSchema={formSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Form>
        <FormikAutoSubmit />
        <Field
          name="numberOfApplicants"
          label="Job board applicants"
          placeholder="Any"
          size="small"
          component={FormSelect}
          options={numberOfApplicantsOptions}
          anchorToBody
        />
      </Form>
    </Formik>
  );
};

NumberOfApplicantsFilter.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([null])]),
  setFilters: PropTypes.func.isRequired,
};

NumberOfApplicantsFilter.defaultProps = {
  value: null,
};
